import React, { useEffect, useState } from 'react';
interface ProgressIndicatorProps {
  totalSteps: number;
}
export function ProgressIndicator({
  totalSteps
}: ProgressIndicatorProps) {
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      const step = Math.min(Math.floor(scrollPercentage * totalSteps), totalSteps - 1);
      setCurrentStep(step);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [totalSteps]);
  return <div className="fixed left-8 top-1/2 -translate-y-1/2 hidden lg:flex flex-col gap-3 z-50" data-id="element-327">
      {Array.from({
      length: totalSteps
    }).map((_, index) => <div key={index} className={`w-3 h-3 rounded-full transition-all duration-300 ${index <= currentStep ? 'bg-purple-600 scale-125' : 'bg-gray-300'}`} data-id="element-328" />)}
    </div>;
}